var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 18H22.125V13.25C22.125 13.1125 22.0125 13 21.875 13H14.125V10H17.5C17.775 10 18 9.775 18 9.5V0.5C18 0.225 17.775 0 17.5 0H8.5C8.225 0 8 0.225 8 0.5V9.5C8 9.775 8.225 10 8.5 10H11.875V13H4.125C3.9875 13 3.875 13.1125 3.875 13.25V18H0.625C0.35 18 0.125 18.225 0.125 18.5V27.5C0.125 27.775 0.35 28 0.625 28H9.625C9.9 28 10.125 27.775 10.125 27.5V18.5C10.125 18.225 9.9 18 9.625 18H6.125V15.25H19.875V18H16.375C16.1 18 15.875 18.225 15.875 18.5V27.5C15.875 27.775 16.1 28 16.375 28H25.375C25.65 28 25.875 27.775 25.875 27.5V18.5C25.875 18.225 25.65 18 25.375 18ZM7.75 20.375V25.625H2.5V20.375H7.75ZM10.375 7.625V2.375H15.625V7.625H10.375ZM23.5 25.625H18.25V20.375H23.5V25.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.57ebb21e9643a493c6275f7e7b0f780d.svg";
export { ForwardRef as ReactComponent };